<template>
  <!--begin::Menu 1-->
  <div
    class="menu menu-sub menu-sub-dropdown w-450px w-md-500px"
    data-kt-menu="true"
  >
    <!--begin::Header-->
    <div class="row">
      <span class="col-lg-1 img">
        <img
          src="/media/svg/files/exclamation-circle-white.svg"
          alt=""
          style="width: auto; margin-top: 18px"
          class="mx-2"
        />
      </span>
      <span class="col-lg-11 px-7 py-5 text">{{
        $t("This gives us options for certain clinical trials.")
      }}</span>
    </div>
    <!--end::Header-->
  </div>
  <!--end::Menu 1-->
</template>

<style>
.menu-sub-dropdown {
  box-shadow: 0px 10px 20px rgba(18, 42, 243, 0.1);
  border-radius: 8px 8px 8px 0px;
}

.row .img {
  background: #f2994a;
  border-radius: 8px 0px 0px 0px;
}

.row .text {
  color: #4f4f4f;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
</style>
